import { environment } from '~env/environment';

export const API_BRAND_INFO_ROUTE_V3 = () => `${environment.svcSearch2BaseUrl()}/api/v3/brands`;

// STORYBLOK
export const SB_BRAND_PLP_ROUTE = `{market}/b`;
